/// <reference types="vite/client" />
import { createClient } from '@supabase/supabase-js';

function getEnv(key: string): string {
  if (typeof process !== 'undefined' && process.env && process.env[key]) {
    return process.env[key] as string;
  }
  if (typeof import.meta !== 'undefined' && (import.meta as any).env && (import.meta as any).env[key]) {
    return (import.meta as any).env[key];
  }
  return '';
}

const supabaseUrl = getEnv('VITE_SUPABASE_URL') || getEnv('SUPABASE_URL') || '';
const supabaseAnonKey = getEnv('VITE_SUPABASE_ANON_KEY') || getEnv('SUPABASE_ANON_KEY') || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('[SUPABASE] Atenção: VITE_SUPABASE_URL ou VITE_SUPABASE_ANON_KEY não configuradas.');
}

export const supabase = createClient(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true
    }
  }
);

let supabaseAdminInstance: any = null;

export function setSupabaseAdminInstance(instance: any) {
  supabaseAdminInstance = instance;
}

export function getSupabaseAdmin(): any {
  if (!supabaseAdminInstance) {
    const url = (typeof process !== 'undefined' && process.env?.SUPABASE_URL) || supabaseUrl;
    const serviceKey = (typeof process !== 'undefined' && process.env?.SUPABASE_SERVICE_ROLE_KEY) || supabaseAnonKey;
    supabaseAdminInstance = createClient(url, serviceKey, {
      auth: {
        persistSession: false,
        autoRefreshToken: false
      }
    });
  }
  return supabaseAdminInstance;
}
